<template>
  <div class="category-content">
    <div class="main-width">
      <div>
        <div style="margin: 10px 0;font-size: 14px;">请选中您需要的标签后搜索</div>
        <div class="label-wrap">
          <el-checkbox-group v-model="labelValue" size="mini">
            <span v-for="(item,index) in labelOrigin" :key="index">
              <div class="label-box">
                <span style="color: #999">{{item.labelName}}</span>：
                <span  v-for="(itm,idx) in item.labelVos" :key="idx">
                  <template v-if="itm.tips">
                    <el-popover trigger="hover" placement="top" popper-class="label-popover">
                      <div class="popover-center">
                        {{itm.tips}}
                      </div>
                      <span slot="reference">
                        <el-checkbox :label="itm.labelName" border>{{itm.labelName}}</el-checkbox>
                      </span>
                    </el-popover>
                  </template>
                  <template v-else>
                     <el-checkbox :label="itm.labelName" border>{{itm.labelName}}</el-checkbox>
                  </template>
                </span>
              </div>
            </span>

            <div>
              <div style="text-align: right;margin: 10px 0;padding-right: 30px;box-sizing: border-box;">
                <el-button style="background-color: #ffa726;border-color: #ffa726" type="danger" size="mini" @click="init">搜索</el-button>
                <span style="width: 10px;display: inline-block;"></span>
                <el-button style="border-color: #ffa726;color: #ffa726;" size="mini" plain @click="reset">重置</el-button>
              </div>
            </div>
          </el-checkbox-group>
        </div>
        <div style="margin: 30px 0 10px;font-size: 12px;color: #bca365;">
          温馨提示：商品标签仅作参考，实际以货架生效为准
          <div style="float: right;margin-top: -10px;">
            <el-button style="color: #ffa726" type="text" size="small">
              <router-link style="color: #ffa726;text-decoration:underline" tag="a" :to="{name: 'DownloadList'}">
                下载列表
              </router-link>
            </el-button>
            <span style="width: 10px;display: inline-block;"></span><el-tooltip
                class="item"
                effect="dark"
                content="将本页所有商品添加报价至报价篮子，前往报价篮子可以批量导出商品报价"
                placement="top"
                popper-class="custom-width"
              >
            <el-button style="background-color: #ffa726;border-color: #ffa726" type="danger" size="small" @click="getPriceAll">批量获取报价</el-button>
            </el-tooltip>
            <span style="width: 10px;display: inline-block;"></span>
            <!-- <el-button style="background-color: #ffa726;border-color: #ffa726" type="danger" size="small"  v-loading="loading.export" @click="exportFn">导出报价表</el-button> -->
            <span style="width: 10px;display: inline-block;"></span>
            <el-button style="background-color: #ffa726;border-color: #ffa726" type="danger" size="small" @click="addNewShelvesAll">批量加入货架</el-button>
          </div>
        </div>
        <el-table v-show="hasGoods" :data="tableData" tooltip-effect="dark" fit class="table-static th-eee" id="table-scroll" style="border-top: 1px solid #EBEEF5;">
            <el-table-column prop="status" label="商品信息" align="center" min-width="400">
              <template slot-scope="scope">
                <div class="goods-info">
                  <el-popover trigger="hover" placement="top" popper-class="table-popover">
                    <div class="table-popover">
                      <img style="width: 240px;height: 240px;" :src="scope.row.goodsPicture" @error="error(1)">
                      <table border="0" cellspacing="10">
                        <tr  style="color: #666">
                          <th width="160px">SKU</th>
                          <th>带票结算价（+运费）</th>
                          <th>库存</th>
                        </tr>
                        <tr style="color: #333" v-for="(item,index) in scope.row.products" :key="index" v-if="index < 7">
                          <template>
                          <td><div style="width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.specName}}</div></td>
                          <td>￥{{item.settlementPrice/100}}（+{{item.freight/100}}）</td>
                          <td>{{item.inventoryNum}}</td>
                          </template>
                        </tr>
                      </table>
                    </div>
                    <span slot="reference">
                      <router-link
                        tag="a"
                        target="_blank"
                        :to="{name: 'Detail', query: {goodsId: scope.row.goodsId}}"
                      >
                        <div class="goods-img">
                          <img :src="scope.row.goodsImage" @error="error(1)" />
                          <div class="category-cover-image" :class="{'a':scope.row.hasTax==1}"></div>
                        </div>
                      </router-link>
                    </span>
                  </el-popover>
                  <div style="margin-left: 15px;text-align: left">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      v-bind:content="scope.row.goodsName"
                      placement="top"
                    >
                      <div style="font-size: 14px;text-align: left;color: #333;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{scope.row.goodsName}}</div>
                    </el-tooltip>
                    <div style="font-size: 14px;margin: 5px 0;text-align: left;color: #666">品牌：{{scope.row.brandName}}</div>
                    <div class="type-icon" style="display: inline-block;line-height: 22px;text-align: center;" v-if="scope.row.supplyChannel > 1">社群集采</div>
                    <div class="type-icon" style="display: inline-block;line-height: 22px;text-align: center;" v-if="scope.row.supplyChannel == 1">一件代发</div>
                    <div class="type-icon" style="background-color: rgb(231,249,235);color: rgb(88,191,106);margin-top: 10px;display: inline-block;line-height: 22px;text-align: center;" v-if="scope.row.isSelf == 1">自产自销</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="标签" align="center" min-width="300">
              <template slot-scope="scope">
                <span v-for="(item,index) in scope.row.labelArr" :key="index" class="table-label-tip">{{item}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="建议零售价" align="center" width="100">
              <template slot-scope="scope">
                ￥{{scope.row.salePrice/100}}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="结算价" align="center" width="160">
              <template slot-scope="scope">
                <div style="color: #ffa726">￥{{scope.row.originSettlementPrice/100}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="毛利" align="center" width="100">
              <template slot-scope="scope">
                ￥{{(scope.row.salePrice - scope.row.settlementPrice).toFixed(2) / 100}}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="毛利率" align="center" width="100">
              <template slot-scope="scope">
                {{(
                      ((scope.row.salePrice - scope.row.settlementPrice) /
                        scope.row.salePrice) *
                      100
                    ).toFixed(2) + "%"}}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="操作" align="center" width="120">
              <template slot-scope="scope">
                <!-- <el-button style="background-color: #ffa726;border-color: #ffa726" type="danger" :disabled="scope.row.shelvesStatus == 1" @click="addNewShelves(scope.row)">加入货架</el-button> -->
                <div
                  style="margin-top: 0;height: 40px;background-color: #ffa726;border-color: #ffa726;color: #fff;"
                  class="category-goods-add-default"
                  v-if="scope.row.shelvesStatus == 0"
                  @click="addNewShelves(scope.row)"
                >加入货架</div>
                <div style="margin-top: 0;height: 40px;" class="category-goods-add-default yishangjia" v-if="scope.row.shelvesStatus == 1">已加入货架</div>
                 <el-tooltip
                      v-if="true"
                      class="item"
                      effect="dark"
                      content="添加商品报价至报价篮子，可以批量导出商品报价"
                      placement="top"
                      popper-class="custom-width"
                    >
                      <div @click="getPrice(scope.row)" class="get-price-label">获取报价</div>
                    </el-tooltip>
                    <el-tooltip
                      v-if="false"
                      class="item"
                      effect="dark"
                      content="该商品已添加至“报价篮子”，可以前往“报价篮子”导出报价！"
                      placement="top"
                    >
                      <div class="get-price-label yet">已添加报价</div>
                    </el-tooltip>
              </template>
            </el-table-column>
        </el-table>
        <div class="block" v-show="hasGoods">
          <el-pagination
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :total="pageTotal"
            :page-size="pageSize"
          ></el-pagination>
        </div>
      </div>
      <div class="category-goods-wrap-no" v-show="!hasGoods">
        <div class="category-goods-wrap-tip">没有找到相关商品...</div>
      </div>
    </div>
    <el-dialog
    title="导出提示"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose">
    <span>导出任务正在生成，请前往【下载列表】中下载您已导出的信息</span>
    <span slot="footer" class="dialog-footer">
      <el-button style="background-color: #ffa726;border-color: #ffa726" type="primary" @click="dialogVisible = false" >好的，我知道了</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title=""
    :visible.sync="dialogVisible2"
    width="600px"
    :before-close="handleClose2">
    <div style="text-align: center">成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！</div>
    <span slot="footer" class="dialog-footer">
      <div class="category-goods-add-default" style="width: 200px;margin: 0 auto;" @click="dialogVisible2 = false" >我知道了</div>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import store from "../store/index.js";
import {
  getLabelInfo,
  getGoodsListByLabel,
  addNewShelves,
  addGoodsAppReport
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      hasGoods: true,
      pageTotal: 0,
      pageNum: 1,
      pageSize: 60,
      tableData: [],
      labelValue: [],
      labelOrigin: [],
      queryFlag: {
        // 是否可发送请求
        export: true,
      },
      loading: {
        // 是否显示loading
        export: false,
      },
      dialogVisible: false,
      dialogVisible2: false,
    };
  },
  created() {

  },
  computed: {

  },
  watch: {

    $route(to, from) {
      console.log("路由改变");
      location.reload(true);

    },

  },
  mounted() {
    this.getLabelInfo();
    this.init();
  },
  updated() {},
  methods: {
    getPriceAll(){
      let _this = this;
      let goodsIdList = [];
      this.tableData.forEach((item,index) => {
        // if(item.shelvesStatus == 0){
          item.productLabels.forEach((itm,idx) => {
            goodsIdList.push(item.goodsId);
          })
        // }
      })
      var data = {
        goodsIdList: goodsIdList,
        appId: this.$store.state.appId,
      };
      fetch(addGoodsAppReport, data).then((res) => {
        if(res.code == 10000){
        _this.dialogVisible2 = true;
        }
      });
    },
    getPrice(row){
      let _this = this;
      var data = {
        goodsIdList: [row.goodsId],
        appId: this.$store.state.appId,
      };
      fetch(addGoodsAppReport, data).then((res) => {
        // _this.dialogVisible2 = true;
        if(res.code == 10000){
          toast('已加入报价篮子', 1, false);
        }
      });
    },
    handleClose(){
      this.dialogVisible = true;
    },
    handleClose2(){
this.dialogVisible2 = true;
    },
    // 导出
    exportFn() {
      if(this.labelValue.length <= 0){
        toast("请选择标签筛选后导出", 3, false);
      }else{

        this.handleExport();
      }
    },
    handleExport() {
      let url = exportGoodsForEs;
      let _this = this;
      if (this.queryFlag.export == true) {
        // this.queryFlag.export = false;
        // this.loading.export = true;
        let params = {
          appId: this.$store.state.appId,
          userId: this.$store.state.userId,
          labelNames: this.labelValue,
        };
        let responseType = "arraybuffer";
        fetch(url, params, responseType)
          .then(res => {
            // let fileName = res.headers["content-disposition"].substring(res.headers["content-disposition"].indexOf("=") + 1);
            // let fileName = '报价表.xlsx';
            // fileDownload(res.data, fileName);
            // _this.queryFlag.export = true;
            // _this.loading.export = false;
            // toast("导出成功!", 1, false);
            this.dialogVisible = true;
          })
          .catch(function(err) {
            // _this.queryFlag.export = true;
            // _this.loading.export = false;
            toast("导出失败！", 2, false);
          });
      }
    },
    // 重置搜索
    reset(){
      this.labelValue = [];
      this.init();
    },
    addNewShelvesAll(){
      let goodsList = [];
      this.tableData.forEach((item,index) => {
        if(item.shelvesStatus == 0){
          item.productLabels.forEach((itm,idx) => {
            let obj = {};
            obj.productId = itm.productId;
            obj.goodsId = item.goodsId;
            obj.hasTax = item.hasTax;
            obj.appType = item.appType;
            goodsList.push(obj);
          })
        }
      })
      let params = {
        goodsList: goodsList,
        userId: this.$store.state.userId,
      };
      fetch(addNewShelves, params).then(res => {
        if(res.code = 10000){
          toast('加入成功', 1, false);
          this.init();
        }else{
          toast('加入失败', 2, false);
        }
      });
    },
    addNewShelves(row){
      let goodsList = [];
      row.productLabels.forEach((item,index) => {
        let obj = {};
        obj.productId = item.productId;
        obj.goodsId = row.goodsId;
        obj.hasTax = row.hasTax;
        obj.appType = row.appType;
        goodsList.push(obj);
      })
      let params = {
        goodsList: goodsList,
        userId: this.$store.state.userId,
      };
      fetch(addNewShelves, params).then(res => {
        if(res.code = 10000){
          toast('加入成功', 1, false);
          this.init();
        }else{
          toast('加入失败', 2, false);
        }
      });
    },
    getLabelInfo(){
      let params = {
        appId: this.$store.state.appId,
        userId: this.$store.state.userId,
        bodyId: this.$store.state.bodyId,
        appId: this.$store.state.appId,
      };
      //获取商品
      fetch(getLabelInfo, params).then(res => {
        if(res.code = 10000){
          this.labelOrigin = res.data;
        }
      });
    },
    init(){
      let params = {
        appId: this.$store.state.appId,
        userId: this.$store.state.userId,
        labelNames: this.labelValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      //获取商品
      fetch(getGoodsListByLabel, params).then(res => {
        this.tableData = res.data.result;
        let str = JSON.stringify(this.labelValue);
        this.tableData.forEach((item,index) => {
          let labelArr = [];
          item.labelNames.forEach((itm,idx) => {
            if(str.indexOf('\"'+itm+'\"') != -1){
              labelArr.push(itm);
            }
          })
          item.labelArr = labelArr;
        })
        if (this.tableData.length == 0) {
          this.hasGoods = false;
        } else {
          this.hasGoods = true;
        }
        this.pageTotal = res.data.count;
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.init();
    },
  }
};
</script>
<style >
  .label-wrap{
    padding: 15px 0;
    box-sizing: border-box;
    border: 1px solid #e9e9e9;
  }
  .label-wrap .label-box{
    font-size: 12px;
    padding: 15px;
    box-sizing: border-box;
    border-bottom: 1px dashed #e9e9e9;
  }
  .label-wrap .label-box .el-checkbox__input{
    display: none;
  }
  .label-wrap .label-box .el-checkbox__label{
    padding: 0;
  }
  .label-wrap .label-box .el-checkbox{
    padding: 3px 10px;
    margin-right: 15px;
  }
  .label-wrap .label-box .el-checkbox.is-checked{
    border-color: #fd7c5d;
  }
  .label-wrap .label-box .el-checkbox.is-checked .el-checkbox__label{
    color: #fd7c5d;
  }
  .label-wrap .el-divider--horizontal{
    margin: 15px 0;
  }
 .label-popover{word-break: normal;min-width: auto;max-width: 20%;color:#fff; background: rgba(0,0,0,0.5);border: none}
 .label-popover.el-popper[x-placement^=top] .popper__arrow::after{border-top-color: rgba(0,0,0,0.5);}
.label-popover.el-popper[x-placement^=bottom] .popper__arrow::after{border-bottom-color: rgba(0,0,0,0.5);}
.category-cover-image.a {
  background: url(../assets/img/hanshui.png) no-repeat top right/45px 45px;
}
.category-cover-image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: url(../assets/img/buhanshui.png) no-repeat top right/45px 45px;
}
.goods-img{
  position: relative;
  width: 120px;
  height: 120px;
}
.goods-img img{
  width: 100%;
  height: 100%;;
}
.table-popover{
  display: -webkit-box;
	display: -webkit-flex;
	display: flex;
	-webkit-box-align: start;
	-webkit-align-items: flex-start;
	align-items: flex-start;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
  justify-content: center;
  background-color: #FAFAFA;
}
.type-icon {
  width: 60px;
  height: 22px;
  background: rgba(255, 248, 249, 1);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 77, 94, 1);
  line-height: 17px;
}
.goods-info{
  display: -webkit-box;
	display: -webkit-flex;
  display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	align-items: center;
}
.table-label-tip{
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  border-color: #fd7c5d;
  color: #fd7c5d;
  font-size: 12px;
  padding: 0 5px;
  box-sizing: border-box;
  margin: 5px;
}
.th-eee th{
  background-color: #eee;
}
.custom-width{
  width: 200px;
}
.get-price-label {
  margin-top: 10px;
  height: 38px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #ffa726;
  color: #ffa726;
  cursor: pointer;
  background-color: #fff;
}
.get-price-label.yet{
    background-color: #c0c0c0;
    color: #fff;
    border: 1px solid #c0c0c0;
}

</style>



// WEBPACK FOOTER //
// CategoryLabel.vue?4cca93d8